export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';
export const UPDATE_MODAL = 'UPDATE_MODAL';
export const OPEN_MODAL_WINDOW = 'OPEN_MODAL_WINDOW';
export const CLOSE_MODAL_WINDOW = 'CLOSE_MODAL_WINDOW';
export const CLOSE_ALL_MODAL_WINDOWS = 'CLOSE_ALL_MODAL_WINDOWS';

export function closeModal() {
  return {
    type: CLOSE_MODAL
  };
}

export function closeAllModals() {
  return {
    type: CLOSE_ALL_MODALS
  };
}

export function openModal(options) {
  return {
    type: OPEN_MODAL,
    payload: {
      ...options
    }
  };
}

export function updateModal(modalkey, targetPropName, newValue) {
  return {
    type: UPDATE_MODAL,
    payload: {
      modalkey,
      targetPropName,
      newValue
    }
  };
}

export function closeWindow() {
  return {
    type: CLOSE_MODAL_WINDOW
  };
}

export function closeAllWindows() {
  return {
    type: CLOSE_ALL_MODAL_WINDOWS
  };
}

export function openWindow(options) {
  return {
    type: OPEN_MODAL_WINDOW,
    payload: {
      options
    }
  };
}
